import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'
import './plugins/element.js'
import './plugins/vue-lazyload.js'
import '@/assets/css/common.scss'
import commonFunc from './plugins/common'

// 挂载
Vue.prototype.$commonFunc = commonFunc

// 设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false

// 日期格式
Vue.filter('date', v => {
  return v.split(' ')[0]
})
Vue.filter('day', v => {
  return v.split(' ')[0].slice(5)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
